import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useFetchWithSpinner } from "../../hooks/useFetchWithSpinner";
import {
  BarChartSummary,
  BarChartComparison,
  LineChartComparison,
  ComparativeTable
} from "../Charts";
import { selectDates, selectTopN, selectComparisonYear } from "../../redux/slices/filtersSlice";
import {
  filterData,
  processFilteredData,
  applyFilterLogic
} from "../../utils/filterFunctions";
import "./Pages.css";

const Llamadas123 = () => {
  const [data, setData] = useState([]);

  const dates = useSelector(selectDates);
  const comparisonYear = useSelector(selectComparisonYear);
  const topN = useSelector(selectTopN);

  const baseFilters = {
    tipo: null,
    barrio: null,
    comuna: null,
    mes: null,
    diaJornada: null,
  };
  const [filters, setFilters] = useState({ ...baseFilters });
  const [frozenKey, setFrozenKey] = useState(null);
  const fetchWithSpinner = useFetchWithSpinner();

  useEffect(() => {
    if (dates.start && dates.end) {
      fetchWithSpinner({
        startDate: dates.start,
        endDate: dates.end,
        year_to_compare: comparisonYear,
        endpoint: 'llamadas/',
      }, setData);
    }
  }, [dates.start, dates.end, comparisonYear]);

  const currentYear = dates.end ? new Date(dates.end).getFullYear() : new Date().getFullYear();

  const filteredData = filterData(data, filters);

  const dias = [...new Set(data.map(h => h.dia))];
  const jornadas = [...new Set(data.map(h => h.jornada))];

  const results = processFilteredData(filteredData, {
    includeTotals: true,
    groupByFields: ["mes", "comuna", "tipo", "barrio"],
    includeDayShift: true,
    dias,
    jornadas
  }, comparisonYear, currentYear);

  const { totals: { total1, total2, diferencia, variacion }, resumenData } = results;
  const mesData = results.groups.mes;
  const comunaData = results.groups.comuna.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));
  const tipoDataRaw = results.groups.tipo.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));
  const tipoData = tipoDataRaw.slice(0, Math.min(topN, tipoDataRaw.length));
  const barrioDataRaw = results.groups.barrio.sort((a, b) => (b[currentYear] + b[comparisonYear]) - (a[currentYear] + a[comparisonYear]));
  const barrioData = barrioDataRaw.slice(0, Math.min(topN, barrioDataRaw.length));
  const diasJornadaData1 = results.diasJornadaData[comparisonYear];
  const diasJornadaData2 = results.diasJornadaData[currentYear];

  const handleFilterClick = (tipo, valor, source) => {
    setFilters((prevFilters) =>
      applyFilterLogic(prevFilters, tipo, valor, source, frozenKey, setFrozenKey, baseFilters)
    );
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-grid">
        <div className="row top">
          <div className="card small">
            <BarChartSummary
              resumenData={resumenData}
              diferencia={diferencia}
              variacion={variacion}
              xKey="name"
              title="Resumen general"
              selectedKey={filters.año}
              frozenKey={frozenKey}
              onBarClick={(d) => handleFilterClick("año", d?.category, "Resumen general")}
            />
          </div>
          <div className="card wide">
            <BarChartComparison
              showData={tipoData}
              xKey="name"
              title="Tipo de Llamada"
              selectedKey={filters.tipo}
              frozenKey={frozenKey}
              onBarClick={(d) => handleFilterClick("tipo", d?.category, "Tipo de Llamada")}
            />
          </div>
          <div className="card wide">
            <BarChartComparison
              showData={barrioData}
              xKey="name"
              title="Llamada por barrio"
              selectedKey={filters.barrio}
              frozenKey={frozenKey}
              onBarClick={(d) => handleFilterClick("barrio", d?.category, "Llamada por barrio")}
            />
          </div>
        </div>
        <div className="row middle">
          <div className="column-right">
            <div className="row bottom">
              <div className="card medium">
                <LineChartComparison
                  showData={mesData}
                  xKey="name"
                  title="Llamadas por mes"
                  selectedKey={filters.mes}
                  frozenKey={frozenKey}
                  onBarClick={(d) => handleFilterClick("mes", d?.category, "Llamadas123 por mes")}
                />
              </div>
              <div className="card medium">
                <ComparativeTable
                  previousData={diasJornadaData1}
                  previousYear={comparisonYear}
                  currentData={diasJornadaData2}
                  currentYear={currentYear}
                  title="Llamadas por día y jornada"
                  selectedKey={filters.diaJornada}
                  frozenKey={frozenKey}
                  onBarClick={(d) => handleFilterClick("diaJornada", d?.category, "Llamadas por día y jornada")}
                />
              </div>
            </div>
            <div className="card medium">
              <BarChartComparison
                showData={comunaData}
                xKey="name"
                title="Llamadas por comuna"
                selectedKey={filters.comuna}
                frozenKey={frozenKey}
                onBarClick={(d) => handleFilterClick("comuna", d?.category, "Llamadas por comuna")}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Llamadas123;
